import React, { useState } from "react";
import "./vrGaming.css";

const PRICE_MAP = {
  "60": 100,
  "90": 150,
  "120": 200,
};

const VRGamingForm = () => {
  const [form, setForm] = useState({
    name: "",
    whatsapp: "",
    datetime: "",
    location: "",
    duration: "",
  });

  const [showPayment, setShowPayment] = useState(false);

  const amount = PRICE_MAP[form.duration] || 0;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.whatsapp || !form.datetime || !form.location || !form.duration) {
      alert("Please fill all fields");
      return;
    }

    /* ---- GOOGLE SHEET ---- */
    await fetch("YOUR_GOOGLE_APPS_SCRIPT_URL", {
      method: "POST",
      body: JSON.stringify({
        ...form,
        amount,
      }),
    });

    setShowPayment(true);
  };

  /* ================= UPI ================= */

  const upiLink = `upi://pay?pa=6456303627@upi&pn=Sandhiya&am=${amount}&cu=INR&tn=VR Gaming Booking`;

  return (
    <div className="vr-wrapper">

      {!showPayment ? (
        <form className="vr-card" onSubmit={handleSubmit}>
          <h2>VR Gaming Registration</h2>

          <input
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
          />

          <input
            name="whatsapp"
            placeholder="WhatsApp Number"
            value={form.whatsapp}
            onChange={handleChange}
          />

          <input
            type="datetime-local"
            name="datetime"
            value={form.datetime}
            onChange={handleChange}
          />

          <select name="location" value={form.location} onChange={handleChange}>
            <option value="">Select Location</option>
            <option value="Chennai">Chennai</option>
            <option value="Pondicherry">Pondicherry</option>
          </select>

          <select name="duration" value={form.duration} onChange={handleChange}>
            <option value="">How Many Hours</option>
            <option value="60">60 Min – ₹100</option>
            <option value="90">90 Min – ₹150</option>
            <option value="120">120 Min – ₹200</option>
          </select>

          <div className="price-box">
            Total Amount <b>₹{amount}</b>
          </div>

          <button type="submit">Proceed to Pay</button>
        </form>
      ) : (
        <div className="payment-card">
          <h2>Complete Payment</h2>

          <div className="amount">₹{amount}</div>

          <a href={upiLink} className="qr-box">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
                upiLink
              )}`}
              alt="UPI QR"
            />
            <p>Tap QR to Pay</p>
          </a>

          <a href={upiLink} className="pay-btn">
            Pay Now with GPay / UPI
          </a>

          <div className="bank-details">
            <p><b>Name:</b> Sandhiya</p>
            <p><b>Account:</b> 6456303627</p>
            <p><b>IFSC:</b> IDIB000T029</p>
            <p><b>Bank:</b> Indian Bank</p>
            <p><b>Branch:</b> Thirukkanur</p>
          </div>
        </div>
      )}

    </div>
  );
};

export default VRGamingForm;
